import { render, staticRenderFns } from "./StatisticsChart.vue?vue&type=template&id=5e6516db&scoped=true"
import script from "./StatisticsChart.vue?vue&type=script&lang=js"
export * from "./StatisticsChart.vue?vue&type=script&lang=js"
import style0 from "./StatisticsChart.vue?vue&type=style&index=0&id=5e6516db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6516db",
  null
  
)

export default component.exports